"use client";

import { ComponentInfo } from "@builder.io/sdk-react";

export const PRODUCT_STANDARD_DETAILS_CONTAINER_INPUTS = [
  {
    name: "sku",
    type: "string",
  },
  {
    name: "productName",
    type: "string",
  },
  {
    name: "description",
    type: "string",
  },
  {
    name: "currentVariantId",
    type: "string",
  },
  {
    name: "isBundle",
    type: "boolean",
  },
  {
    name: "multiPackProducts",
    type: "list",
  },
  {
    name: "bundlesConfig",
    type: "list",
  },
  {
    name: "categories",
    type: "list",
    subFields: [
      {
        name: "name",
        type: "string",
        required: true,
      },
      {
        name: "id",
        type: "string",
        required: true,
      },
    ],
  },
  {
    name: "hideCta",
    type: "boolean",
  },
  {
    name: "isTrial",
    type: "boolean",
  },
  {
    name: "configurableOptions",
    type: "list",
  },
  {
    name: "dynamicGallery",
    type: "list",
  },
  {
    name: "videoGallery",
    type: "list",
  },
  {
    name: "trustpilot",
    type: "object",
    subFields: [
      {
        name: "isEnabled",
        type: "boolean",
      },
    ],
  },
  {
    name: "productCta",
    type: "object",
    subFields: [
      {
        name: "label",
        type: "string",
      },
      {
        name: "url",
        type: "string",
      },
    ],
  },
  {
    name: "multiPackName",
    type: "string",
  },
  {
    name: "multiPackDescription",
    type: "string",
  },
  {
    name: "galleryAssets",
    type: "list",
    subFields: [
      {
        name: "path",
        type: "string",
        required: true,
      },
      {
        name: "type",
        type: "string",
        enum: ["image", "video"],
        required: true,
        defaultValue: "image",
      },
      {
        name: "position",
        type: "number",
      },
    ],
  },
  {
    name: "hasDiscountBadge",
    type: "boolean",
  },
  {
    name: "isMultiPackEnabled",
    type: "boolean",
  },
  {
    name: "hasStrikethroughPrice",
    type: "boolean",
  },
  {
    name: "isCommerceDisabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "knowMoreUrl",
    type: "string",
  },
  {
    name: "isDynamicGalleryEnabled",
    type: "boolean",
  },
  {
    name: "currentVariantSku",
    type: "string",
  },
  {
    name: "nonTradeInSku",
    type: "string",
  },
] as const satisfies ComponentInfo["inputs"];

export type StandardProductDetailsContainerProps = BuilderComponentProps<
  typeof PRODUCT_STANDARD_DETAILS_CONTAINER_INPUTS
>;
